module.exports = __webpack_public_path__ + "img/home-back-two@3x.faceaefa.jpg";